import React from 'react';
import { motion } from 'framer-motion';
import { ScaleIcon, RulerIcon, SofaIcon, EyeIcon, GridIcon } from 'lucide-react';
export function PowerBullets() {
  const bullets = [{
    icon: ScaleIcon,
    title: 'Cortinas con Caída de Mármol',
    description: 'Aprende a instalar pesos de plomo invisibles y dobladillos de 15cm para que tu tela tenga autoridad.'
  }, {
    icon: RulerIcon,
    title: 'El Pliegue Francés de 3 Puntas',
    description: 'La técnica matemática para que tus cabezales sean rígidos y elegantes, no caídos.'
  }, {
    icon: SofaIcon,
    title: 'Cojines "Over-Stuffed"',
    description: 'El truco de la talla menor para que tus sofás luzcan firmes y lujosos permanentemente.'
  }, {
    icon: EyeIcon,
    title: 'Engaña al Ojo Experto',
    description: 'Te enseño a elegir lonetas de $5 que, tratadas con mi método, parecen sedas y linos de $100 el metro.'
  }, {
    icon: GridIcon,
    title: 'Escuadre de Hilo Maestro',
    description: 'El secreto para que tus cortinas jamás se tuerzan, aunque las laves cien veces.'
  }];
  return <section className="bg-white py-12 md:py-18 px-5 md:px-12" data-id="element-113">
      <div className="max-w-4xl mx-auto" data-id="element-114">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-115">
          <div className="h-px w-16 bg-[#C9A96E] mx-auto mb-4" data-id="element-116" />
          <span className="text-[#C9A96E] uppercase tracking-[0.2em] text-xs font-medium block mb-4" data-id="element-117">
            Lo Que Vas a Lograr
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif text-[#1C1C1C]" data-id="element-118">
            Técnicas de{' '}
            <span className="italic text-[#C9A96E]" data-id="element-119">Alto Nivel</span>
          </h2>
        </motion.div>

        {/* Bullets Grid */}
        <div className="space-y-4" data-id="element-120">
          {bullets.map((bullet, index) => <motion.div key={bullet.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group flex items-start gap-4 p-5 md:p-6 bg-[#FAF7F2] border border-[#C9A96E]/10 rounded-xl hover:border-[#C9A96E]/30 transition-colors duration-300" data-id="element-121">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#C9A96E]/10 border border-[#C9A96E]/20 flex items-center justify-center group-hover:bg-[#C9A96E]/20 transition-colors duration-300" data-id="element-122">
                <bullet.icon className="w-4 h-4 text-[#C9A96E]" data-id="element-123" />
              </div>
              <div data-id="element-124">
                <h3 className="text-lg md:text-xl font-serif text-[#1C1C1C] mb-2 group-hover:text-[#C9A96E] transition-colors duration-300" data-id="element-125">
                  {bullet.title}
                </h3>
                <p className="text-[#1C1C1C]/70 leading-relaxed text-sm md:text-base" data-id="element-126">
                  {bullet.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}